module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar disabled = false;\nif(!!formMapping && !!formMapping.fieldConfig) {\ndisabled = !!formMapping.fieldConfig.disabled;\n}\nvar value = '';\nvar maxOptionsIndex;\n// prepare config\nvar renderConfig = model.config && model.config.renderConfig ? model.config.renderConfig : {};\nvar groupConfig = renderConfig.groupEntries || {};\ngroupConfig = utils.replace({ children: 'children', valuePrefix: '' }, groupConfig);\nvar childConfig = renderConfig.optionEntries || {};\nchildConfig = utils.replace({ value: 'value', name: 'name' }, childConfig);\nvar isGrouped = !!groupConfig.name;\n// prepare user-lang\nvar langCode = storage.langCode\n// prepare source-data-flag\nvar dataAttributeKey;\nif(!!model.atom && !!model.atom.dataType){\ndataAttributeKey = model.atom.dataType + '-data';\n} else {\ndataAttributeKey = 'data';\n}\n// prepare options\nvar options;\nif(Array.isArray(model[dataAttributeKey])){\noptions = model[dataAttributeKey];\n}\nelse if(!!model[dataAttributeKey] && !!model[dataAttributeKey].options){\noptions = model[dataAttributeKey].options;\n}\n// prepare default entry\nif(renderConfig.defaultOptionEntry){\nvar entry = {};\nif(langCode && renderConfig.defaultOptionEntry.lang && renderConfig.defaultOptionEntry.lang[langCode]){\nentry[childConfig.name] = renderConfig.defaultOptionEntry.lang[langCode];\nentry[childConfig.value] = renderConfig.defaultOptionEntry.value;\n}\nelse {\nentry[childConfig.name] = renderConfig.defaultOptionEntry.name;\nentry[childConfig.value] = renderConfig.defaultOptionEntry.value;\n}\noptions.unshift(entry);\n}\nvar optionListHtml = '';\nif(!!options){\nvar optionConfig = childConfig;\nutils.forEach(options, function(option, optionIndex){\nmaxOptionsIndex = optionIndex;\n// define option name\nvar optionName;\nif(!!option.lang && !!langCode && !!option.lang[langCode] && !!option.lang[langCode][optionConfig.name]){\noptionName = option.lang[langCode][optionConfig.name];\n} else if (!!option[optionConfig.name]) {\noptionName = option[optionConfig.name];\n} else {\noptionName = '-NO-NAME-FOUND-';\n}\n// define if option is selected\nvar optionSelected = false;\nif(Array.isArray(model.dataJSON)){\noptionSelected = utils.indexOf(model.dataJSON, option.value) >= 0;\n} else if(model.dataTEXT != undefined && model.atom.dataType === 'template-picker'){\noptionSelected = option[optionConfig.value] == model.dataTEXT;\n} else {\noptionSelected = !!option.defaultSelected;\n}\nif(optionSelected) value = option[optionConfig.value];\noptionListHtml += include('./autoCompleteTextOption', { model: { disabled: optionIndex >= config.maxNrOfElements, value: option[optionConfig.value], name: optionName }});\n});\n}\nif(maxOptionsIndex >= config.maxNrOfElements){\noptionListHtml += '<div class=\"end\">...</div>';\n}\n%>\n<div>\n<input data-field-type=\"text\" type=\"text\" placeholder=\"<%- model.dataTEXT || '' %>\" title=\"<%- model.dataTEXT || '' %>\" data-field-code=\"<%- model.fieldCode %>\" value=\"<%= value %>\"<%- (disabled ? 'disabled=\"disabled\"' : ''); %> />\n<ul>\n<%- optionListHtml %>\n</ul>\n</div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\autoCompleteText.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var disabled = false;
if(!!formMapping && !!formMapping.fieldConfig) {
disabled = !!formMapping.fieldConfig.disabled;
}
var value = '';
var maxOptionsIndex;
// prepare config
var renderConfig = model.config && model.config.renderConfig ? model.config.renderConfig : {};
var groupConfig = renderConfig.groupEntries || {};
groupConfig = utils.replace({ children: 'children', valuePrefix: '' }, groupConfig);
var childConfig = renderConfig.optionEntries || {};
childConfig = utils.replace({ value: 'value', name: 'name' }, childConfig);
var isGrouped = !!groupConfig.name;
// prepare user-lang
var langCode = storage.langCode
// prepare source-data-flag
var dataAttributeKey;
if(!!model.atom && !!model.atom.dataType){
dataAttributeKey = model.atom.dataType + '-data';
} else {
dataAttributeKey = 'data';
}
// prepare options
var options;
if(Array.isArray(model[dataAttributeKey])){
options = model[dataAttributeKey];
}
else if(!!model[dataAttributeKey] && !!model[dataAttributeKey].options){
options = model[dataAttributeKey].options;
}
// prepare default entry
if(renderConfig.defaultOptionEntry){
var entry = {};
if(langCode && renderConfig.defaultOptionEntry.lang && renderConfig.defaultOptionEntry.lang[langCode]){
entry[childConfig.name] = renderConfig.defaultOptionEntry.lang[langCode];
entry[childConfig.value] = renderConfig.defaultOptionEntry.value;
}
else {
entry[childConfig.name] = renderConfig.defaultOptionEntry.name;
entry[childConfig.value] = renderConfig.defaultOptionEntry.value;
}
options.unshift(entry);
}
var optionListHtml = '';
if(!!options){
var optionConfig = childConfig;
utils.forEach(options, function(option, optionIndex){
maxOptionsIndex = optionIndex;
// define option name
var optionName;
if(!!option.lang && !!langCode && !!option.lang[langCode] && !!option.lang[langCode][optionConfig.name]){
optionName = option.lang[langCode][optionConfig.name];
} else if (!!option[optionConfig.name]) {
optionName = option[optionConfig.name];
} else {
optionName = '-NO-NAME-FOUND-';
}
// define if option is selected
var optionSelected = false;
if(Array.isArray(model.dataJSON)){
optionSelected = utils.indexOf(model.dataJSON, option.value) >= 0;
} else if(model.dataTEXT != undefined && model.atom.dataType === 'template-picker'){
optionSelected = option[optionConfig.value] == model.dataTEXT;
} else {
optionSelected = !!option.defaultSelected;
}
if(optionSelected) value = option[optionConfig.value];
optionListHtml += include('./autoCompleteTextOption', { model: { disabled: optionIndex >= config.maxNrOfElements, value: option[optionConfig.value], name: optionName }});
});
}
if(maxOptionsIndex >= config.maxNrOfElements){
optionListHtml += '<div class="end">...</div>';
}

    ; __line = 75
    ; __append("\n<div>\n<input data-field-type=\"text\" type=\"text\" placeholder=\"")
    ; __line = 77
    ; __append( model.dataTEXT || '' )
    ; __append("\" title=\"")
    ; __append( model.dataTEXT || '' )
    ; __append("\" data-field-code=\"")
    ; __append( model.fieldCode )
    ; __append("\" value=\"")
    ; __append(escapeFn( value ))
    ; __append("\"")
    ; __append( (disabled ? 'disabled="disabled"' : '') )
    ; __append(" />\n<ul>\n")
    ; __line = 79
    ; __append( optionListHtml )
    ; __append("\n</ul>\n</div>")
    ; __line = 81
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\autoCompleteText.ejs

}